import { Button } from "@/components/ui/button";
import { useAccountProxy } from "@/stores/account.store";
import { Separator } from "@radix-ui/react-dropdown-menu";
import { CreditCard } from "lucide-react";

export function OrganizationPage() {
  const accountProxy = useAccountProxy();

  const handleUpdatePaymentMethod = () => {
    accountProxy.setupPaymentMethod();
  };
  return (
    <div className="p-6 pb-16 space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Organization</h1>
        <p className="text-muted-foreground">
          Manage your organization's settings
        </p>
      </div>
      <Separator />
      <div className="flex p-5 rounded-md bg-muted justify-between">
        <div className="flex flex-col">
          <div className="text-lg font-bold">
            Update your organization's payment method
          </div>
          <div className="italic font-extralight">
            A payment method is required to subscribe to any plan on the
            platform
          </div>
        </div>

        <Button
          className="flex self-center gap-2"
          onClick={handleUpdatePaymentMethod}
        >
          <span>Update the payment method</span>
          <CreditCard className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
